import React from "react";
import { useParams } from "react-router-dom";

import FormNotesView from "components/FormNotesView";
import { API_SUBAWARD, COLUMN_HEADER_KEYS } from "globals/constants";
import { useFormAccesses } from "hooks";
import { getSubaward } from "store/actions/subaward";


const SubawardNotesView = () => {
	const { awardId, subawardId } = useParams();

	const formAccesses = useFormAccesses(COLUMN_HEADER_KEYS.SUBAWARD, subawardId);

	const formInstance = {
		instanceId: subawardId,
		endpoint: API_SUBAWARD,
		type: COLUMN_HEADER_KEYS.SUBAWARD
	};

	return (
		<FormNotesView
			formInstance = { formInstance }
			canAddNotes = { formAccesses.addContent }
			canEditNotes = { formAccesses.updateContent }
			refreshForm = { getSubaward }
		/>
	);
};

export default SubawardNotesView;
